import React from 'react';
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  useTheme,
} from '@mui/material';
import {
  Language as LanguageIcon,
  Brightness4 as DarkModeIcon,
  Brightness7 as LightModeIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const QuickSettings = ({ open, onClose, onLanguageClick, onLogoutClick, onThemeToggle, isDarkMode, churchName, churchCode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  const handleMoreSettings = () => {
    navigate('/app/settings');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: 360,
          mx: 2,
        }
      }}
    >
      <DialogTitle>
        <Typography variant="h6" component="div">
          {t('settings.quickSettings')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {churchName}
          <br />
          {t('settings.churchCode')}: {churchCode}
        </Typography>
      </DialogTitle>
      <Divider />
      <List>
        <ListItem button onClick={onLanguageClick}>
          <ListItemIcon>
            <LanguageIcon />
          </ListItemIcon>
          <ListItemText primary={t('settings.appLanguage')} />
        </ListItem>

        <ListItem button onClick={onThemeToggle}>
          <ListItemIcon>
            {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
          </ListItemIcon>
          <ListItemText primary={t('settings.colorScheme')} secondary={isDarkMode ? t('settings.lightMode') : t('settings.darkMode')} />
        </ListItem>

        <ListItem button onClick={handleMoreSettings}>
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary={t('settings.moreSettings')} />
        </ListItem>

        <Divider />

        <ListItem button onClick={onLogoutClick}>
          <ListItemIcon>
            <LogoutIcon color="error" />
          </ListItemIcon>
          <ListItemText 
            primary={t('settings.logout')} 
            primaryTypographyProps={{ color: 'error' }}
          />
        </ListItem>
      </List>
    </Dialog>
  );
};

export default QuickSettings;
